var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1:2839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.83316C5.68234 0.83316 5.8572 0.917665 5.98614 1.06809C6.11507 1.2185 6.1875 1.42252 6.1875 1.63524V6.44774H10.3125C10.4948 6.44774 10.6697 6.53225 10.7986 6.68267C10.9276 6.83309 11 7.0371 11 7.24983C11 7.46255 10.9276 7.66657 10.7986 7.81699C10.6697 7.96741 10.4948 8.05191 10.3125 8.05191H6.1875V12.8644C6.1875 13.0771 6.11507 13.2811 5.98614 13.4316C5.8572 13.582 5.68234 13.6665 5.5 13.6665C5.31766 13.6665 5.1428 13.582 5.01386 13.4316C4.88493 13.2811 4.8125 13.0771 4.8125 12.8644V8.05191H0.6875C0.505164 8.05191 0.330295 7.96741 0.201364 7.81699C0.0724328 7.66657 0 7.46255 0 7.24983C0 7.0371 0.0724328 6.83309 0.201364 6.68267C0.330295 6.53225 0.505164 6.44774 0.6875 6.44774H4.8125V1.63524C4.8125 1.42252 4.88493 1.2185 5.01386 1.06809C5.1428 0.917665 5.31766 0.83316 5.5 0.83316V0.83316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1:2839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12.8333,
    fill: "white",
    transform: "translate(0 0.83316)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.143c90ab04d325704d9a97300d0b6265.svg";
export { ForwardRef as ReactComponent };